import * as $ from "jquery";
import CookiesHelper from "../Helpers/helpers.cookies";

export default class CustomerComponent {
    constructor() {
        this.componentSelector = ".signup";
        this.instance = this;
        this.cookies = new CookiesHelper();
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#customer-market').off().on('change', function () {
            var marketId = $('#customer-market').val();
            instance.loadSignup(marketId, instance);
        });
    }

    loadSignup(marketId, instance) {
        axios({
            method: 'post',
            url: "/customer/getsignup",
            data: { market: marketId }
        }).then(function (response) {
            $('#result').html(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }
}